import React from 'react';

const SupportAction = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.97982 10.55H8.06982C7.65982 10.55 7.31982 10.21 7.31982 9.8C7.31982 9.39 7.65982 9.05 8.06982 9.05H9.97982C10.3898 9.05 10.7298 9.39 10.7298 9.8C10.7298 10.21 10.3898 10.55 9.97982 10.55Z"
      fill="#787F88"
    />
    <path
      d="M10.7298 17.45H8.06982C7.65982 17.45 7.31982 17.11 7.31982 16.7C7.31982 16.29 7.65982 15.95 8.06982 15.95H10.7298C11.1398 15.95 11.4798 16.29 11.4798 16.7C11.4798 17.11 11.1398 17.45 10.7298 17.45Z"
      fill="#787F88"
    />
    <path
      d="M12.7998 14H8.06982C7.65982 14 7.31982 13.66 7.31982 13.25C7.31982 12.84 7.65982 12.5 8.06982 12.5H12.7998C13.2098 12.5 13.5498 12.84 13.5498 13.25C13.5498 13.66 13.2098 14 12.7998 14Z"
      fill="#787F88"
    />
    <path
      d="M23.0002 4.47H20.8502C20.6102 4.47 20.4302 4.24 20.4902 4.01L21.1602 1.46C21.2602 1.08 20.7802 0.830003 20.5202 1.13L16.8202 5.5C16.6202 5.74 16.7902 6.11 17.1002 6.11H19.2502C19.4902 6.11 19.6702 6.34 19.6102 6.57L18.9402 9.12C18.8402 9.5 19.3202 9.75 19.5802 9.45L23.3002 5.08C23.4902 4.84 23.3202 4.47 23.0002 4.47Z"
      fill="#787F88"
    />
    <path
      d="M18.34 23H5.66C3.64 23 2 21.36 2 19.34V6.66C2 4.64 3.64 3 5.66 3H14C14.55 3 15 3.45 15 4C15 4.55 14.55 5 14 5H5.66C4.74 5 4 5.74 4 6.66V19.35C4 20.26 4.74 21 5.66 21H18.34C19.25 21 20 20.26 20 19.34V13C20 12.45 20.45 12 21 12C21.55 12 22 12.45 22 13V19.34C22 21.36 20.36 23 18.34 23Z"
      fill="#787F88"
    />
  </svg>
);
export default SupportAction;
